import React from 'react';
import Spinner from 'react-spinner';

import fetchContent from '../../helpers/backend-communication';
import CountryProfileMenu from './Menu';
import CountryProfileSectionList from './CountryProfileSecionList';

//function getFlagUrlByAlpha2(code) {
  //return `url(dist/images/country-icons/${code}.png)`;
//}

export default class CountryProfile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      isLoading: false
    }
  }

  componentDidMount() {
    console.log("Fetching content for country profile....");

    this.setState({
      isLoading: true
    });

    fetchContent('countryprofile', `/${this.props.countryCode}`)
      .then(responseObject => {
        const countryProfileData = responseObject.sections;
        console.log("Joao", countryProfileData);
        this.setState({
          data: countryProfileData,
          isLoading: false
        });
      })
      .catch(error => {
        this.setState({
          data: [],
          isLoading: false
        });
        console.error('Fetch of NPC went wrong', error);
      });
  }

  render() {
    const { data, isLoading } = this.state;

    let reportContent;

    if (isLoading) {
      reportContent = <Spinner />;
    } else if (data && data.length > 0) {
      reportContent = <CountryProfileSectionList list={ data } />;
    } else {
      reportContent = <p>No report information available.</p>;
    }

    //const flagStyle = {
      //'backgroundImage': getFlagUrlByAlpha2(data.countryCodeAlpha2)
    //};

    return (
      <div>
        <h2 className="title">Implementation status of the Programme of Action</h2>

        <div className="country-profile-header">
          <h1 className="country-profile-title background-country-flag title">
            { this.props.countryName }
          </h1>

          <CountryProfileMenu
            countryName={ this.props.countryName }
            countryCode={ this.props.countryCode }
            npcData={ data[0] && data[0].sub_sections }
          />
        </div>

        { reportContent }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CountryProfile/CountryProfile.js